/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyMemberRoles: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-member-roles", jiraSpaEntry: "async-jira-eoc-member-roles" */ '@jira/eoc__member-roles/src/ui/index.tsx'
		),
);

const AsyncMemberRoles = (): React.JSX.Element => (
	<LazyPage Page={LazyMemberRoles} pageId="async-jira-eoc-member-roles" shouldShowSpinner={false} />
);

export default AsyncMemberRoles;
